import { SUCCESS, REQUEST, FAILED } from 'crom-api-constants'

export const VIRTUAL_LIST_ID = 'favorite_virtual_list'
export const LOCALE_PREFIX = 'scenes.Gnosus.components.EntityStack.components.StackContent.components.FavouritesContent'

export const GET_FAVOURITES = 'GET_FAVOURITES'
export const FAVOURITES_LOADED = 'FAVOURITES_LOADED'
export const ADD_TO_FAVOURITES = 'ADD_TO_FAVOURITES'
export const REMOVE_FROM_FAVOURITES = 'REMOVE_FROM_FAVOURITES'

export const LOAD_FAVOURITES_REQUEST = 'LOAD_FAVOURITES_REQUEST'
export const LOAD_FAVOURITES_REQUEST_SUCCESS = `LOAD_FAVOURITES_${REQUEST}_${SUCCESS}`

export const ADD_TO_FAVOURITES_REQUEST = `ADD_TO_FAVOURITES_${REQUEST}`
export const ADD_TO_FAVOURITES_REQUEST_SUCCESS = `ADD_TO_FAVOURITES_${REQUEST}_${SUCCESS}`
export const ADD_TO_FAVOURITES_REQUEST_FAILED = `ADD_TO_FAVOURITES_${REQUEST}_${FAILED}`

export const REMOVE_FROM_FAVOURITES_REQUEST = `REMOVE_FROM_FAVOURITES_${REQUEST}`
export const REMOVE_FROM_FAVOURITES_REQUEST_SUCCESS = `REMOVE_FROM_FAVOURITES_${REQUEST}_${SUCCESS}`
export const REMOVE_FROM_FAVOURITES_REQUEST_FAILED = `REMOVE_FROM_FAVOURITES_${REQUEST}_${FAILED}`
